import type React from 'react'

// For now, we are trusting dangerouslySetCSS to only be set by Blissbook admins
export const Style: React.FC<{
  dangerouslySetCSS: string
}> = ({ dangerouslySetCSS }) => (
  // biome-ignore lint/security/noDangerouslySetInnerHtml: filtered manually
  <style dangerouslySetInnerHTML={{ __html: dangerouslySetCSS }} />
)
